<template>
    <div class="modal fade" id="productArtworkVersionsModal">
        <div class="modal-dialog" >
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title">Artworks</h5>
                    <button type="button" class="close" data-dismiss="modal"><i  class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body" v-if="order !=null && product != null">
                    <div v-if="errorMessage" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li>{{ errorMessage }}</li>
                        </ul>
                    </div>
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <table class="table table-bordered table-hover">
                            <thead>
                            <tr>
                                <th>Artwork Versions</th>
                                <th>Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template v-if="product.artworks && product.artworks.length > 0">
                                <tr v-for="(artwork, artworkIndex) in product.artworks">
                                    <td>
                                        <div v-if="artwork.id && artwork.attach_link">
                                            <span :title="artwork.attach_link">{{artwork.attach_link | truncate(35)}}</span>
                                            <a v-if="['png', 'jpg', 'jpeg'].some( image => artwork.attach_link.toLowerCase().includes(image))" href="javascript:void(0)" @click="imagePreview(artwork.attach_link)">Preview</a>
                                            <a href="javascript:void(0)" v-on:click="download(artwork)">Download</a> <br>

                                            <div>
                                                <span>V-{{ artwork.version_number }}</span>
                                                <span>Uploaded {{ artwork.uploaded_at }}</span>

                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {{artwork.artwork_status ? artwork.artwork_status.name : null }}
                                        <template v-if="artwork.artwork_status_id == 2">
                                            <span>Sent {{ artwork.sent_at }}</span>
                                        </template>
                                        <template v-if="artwork.artwork_status_id == 4">
                                            <template v-if="!showReason">
                                                <a href="javascript:void(0)" @click="showReason = true">See Reason</a>
                                            </template>
                                            <template v-if="showReason">
                                                {{ artwork.reason }}
                                            </template>

                                        </template>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="2">
                                        No artworks added!
                                    </td>
                                </tr>
                            </template>

                            </tbody>
                        </table>
                    </div>


                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal">Cancel</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Vue from "vue";

export default {
    name: "ProductArtworkVersionsModal",
    props: ['order', 'product'],
    components: {
        vueDropzone: vue2Dropzone,
    },
    created() {

    },
    mounted() {

    },
    data() {
        return {
            submitted: false,
            showReason: false,
            dropzoneOptions: {
                url: window.route('medias.store'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        imagePreview(src) {
            this.$emit('imagePreview', src);
        },
        afterUploadComplete(file, response, artworkIndex) {
            this.product.artworks[artworkIndex].media_id = response.data.media.id;
        },
        removeItemAttach(artworkIndex, product_id, artwork_id = null) {
            if (artwork_id) {
                let self = this;
                Vue.$confirm({
                    title: 'Are you sure?',
                    message: 'Are you sure you want to delete?',
                    button: {
                        yes: 'Yes',
                        no: 'Cancel'
                    },
                    callback: confirm => {
                        if(confirm) {
                            self.setLoading(true);
                            self.setCommonErrors([]);
                            self.setErrorMessage(null);
                            return axios.delete(window.route('orders.products.artworks.destroy', {
                                id: self.order.id,
                                product_id: product_id,
                                artwork_id: artwork_id
                            }), {
                                validateStatus: function (status) {
                                    return status < 500; // Resolve only if the status code is less than 500
                                }
                            })
                                .then(({data}) => {
                                    if (data.errorMessage) {
                                        self.setErrorMessage(data.errorMessage);
                                        if (data.errors) {
                                            self.setCommonErrors(data.errors);
                                        }
                                    } else {
                                        self.setSuccessMessage("Artwork deleted!");
                                        self.product.artworks.splice(artworkIndex, 1);
                                        setTimeout(() => {
                                            self.setSuccessMessage(null);
                                        }, 5000);
                                    }
                                })
                                .catch((error) => {
                                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                                })
                                .finally(() => {
                                    self.setLoading(false);

                                });
                        }

                    }
                });

            } else {
                this.product.artworks.splice(artworkIndex, 1);
            }
        },
        addNewItemAttach() {
            this.product.artworks.push({
                id: null,
                is_approve: 0,
                attach_link: null,
                comment: null,
                updated_at: null,
                media_id: null
            });
        },
        save() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('orders.products.artworks.store', {id: this.order.id,  product_id: this.product.id});

            return axios.post(apiUrl, {artworks: this.product.artworks}, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.data) {
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.$emit('productArtworksUpdated', data.data);
                        $('#productArtworksModal').modal('hide');
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        download(artwork) {
            let url = window.route('medias.download', {
                path: 'so_attachments',
                id: this.order.id,
                name: artwork.attach_link,
                pdf_to_image: 0
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url,  {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", artwork.attach_link);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
